import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import { Link } from "../Link";
import { SocialLinks } from "./SocialLinks";
import LINKS from "../Navbar/constants";

const Footer = () => {
  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, #E4DD6050 0%, #000000 80%, #000000 100%)",
      }}
      width="100%"
      pt={{ xs: 16, md: 24 }}
    >
      <Box width={{ xs: "90%", lg: "80%" }} m="auto">
        <Grid
          container
          spacing={{ xs: 8, md: 0 }}
          columns={{ xs: 4, sm: 4, md: 8 }}
          alignItems="center"
        >
          <Grid item xs={4} sm={4} md={4}>
            <Stack
              spacing={4}
              pl={{ lg: 12 }}
              alignItems={{ xs: "center", sm: "flex-start" }}
            >
              <>
                <a href="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="68"
                    height="48"
                    viewBox="0 0 92 65"
                    fill="none"
                  >
                    <path
                      d="M45.426 0.158705C44.9761 0.437225 44.2048 1.43347 43.7442 2.31188C42.3087 5.07566 41.7088 8.54645 42.0838 11.9315C42.4051 14.931 43.2086 17.3198 44.5905 19.4516C44.9975 20.0836 46.1116 21.3477 46.1866 21.262C46.3151 21.0906 47.3649 19.1409 47.6435 18.541C48.3183 17.0735 49.1325 14.2775 49.4217 12.435C49.6252 11.1281 49.6252 7.111 49.4217 6.1576C49.0789 4.56147 48.2755 2.63325 47.4399 1.42276C46.4865 0.0515823 46.0473 -0.226938 45.426 0.158705Z"
                      fill="white"
                    />
                    <path
                      d="M59.4055 5.73983C58.9127 6.07191 56.1275 8.85711 55.2384 9.91763C53.5137 11.9744 50.3429 17.0735 49.2288 19.6016C48.9931 20.1372 48.329 21.8619 47.7505 23.4259C47.172 24.9899 46.5507 26.5539 46.3793 26.9074L46.0687 27.5287L45.7794 27.0895C45.6187 26.8538 45.0831 25.5898 44.5904 24.2828C43.5084 21.4227 42.8764 20.0086 41.773 17.9519C40.3697 15.3488 37.7559 11.5245 36.1705 9.74624C35.3028 8.78213 32.6675 6.24331 32.3569 6.08263C31.7784 5.77197 31.0714 6.07191 30.6858 6.80035C30.3216 7.46451 30.1716 8.0644 29.7002 10.6996C29.486 11.8887 29.2182 13.3349 29.1003 13.9133C28.7897 15.4666 28.7361 16.4736 28.929 17.3841C29.2825 19.0338 29.5396 19.3445 33.7388 23.2866C36.1919 25.579 36.7704 26.2004 38.013 27.8608C39.0735 29.2641 39.7163 30.2496 40.6804 31.8779C41.1089 32.617 41.7623 33.7204 42.1265 34.3417C43.4334 36.5484 44.6225 38.5945 45.3938 39.9443L46.1758 41.3154L47.2042 39.248C47.7719 38.1124 48.8324 35.9486 49.5716 34.4595C51.7783 29.9604 53.0531 28.0107 55.8383 24.872C56.8238 23.7579 59.1912 21.5619 60.8409 20.2443C61.5694 19.6658 62.3942 18.9695 62.6835 18.7017L63.1977 18.2197L63.1227 16.4521C63.0263 14.1383 62.8334 12.66 62.3085 10.2069C61.8372 8.00013 61.6229 7.2824 61.1837 6.48969C60.616 5.4506 60.1446 5.24706 59.4055 5.73983Z"
                      fill="white"
                    />
                    <path
                      d="M76.247 13.7527C74.4795 14.2133 72.1228 15.1667 69.6054 16.4093C66.7773 17.8233 64.7098 19.1088 63.1244 20.4371C62.1282 21.262 57.8433 25.5469 56.3757 27.1645C54.576 29.157 52.7228 31.8886 50.9124 35.1987C49.5091 37.759 47.8594 41.2297 47.8594 41.6154C47.8594 41.6582 48.0522 41.7868 48.2879 41.8939C48.7056 42.0867 48.7485 42.0867 49.3377 41.8939C50.7303 41.4654 53.7511 39.8264 56.0543 38.2839C57.7683 37.1162 58.3039 36.7092 60.4463 34.8773C63.7029 32.0921 64.2921 31.6422 65.6954 30.9459C67.013 30.2818 68.1913 30.0354 70.8801 29.8426L72.4227 29.7461L73.1726 29.2855C75.4114 27.9358 76.5684 25.9326 77.4361 21.8619C78.036 19.0767 78.3252 16.6878 78.1859 15.8523C78.1217 15.4988 78.0681 14.9096 78.0681 14.5454C78.0681 14.1919 78.036 13.8276 78.0038 13.7312C77.9181 13.5063 77.1683 13.517 76.247 13.7527Z"
                      fill="white"
                    />
                    <path
                      d="M14.4258 14.4704C13.9759 14.7167 13.8473 15.3273 13.858 17.202C13.8687 18.8088 13.8795 18.9374 14.3722 20.8977C14.64 22.0118 14.9935 23.3402 15.1435 23.8329C15.6898 25.6433 17.1788 28.932 17.6181 29.339C17.8323 29.5212 18.4215 29.6497 20.6711 29.9925C23.3277 30.3996 25.5452 31.1816 27.8055 32.5099C29.0481 33.2383 30.1836 34.0953 32.6367 36.1414C36.5146 39.3872 40.8102 41.8832 43.649 42.5473C44.0132 42.633 44.3881 42.7294 44.4738 42.7616C44.7095 42.8473 44.4631 42.1724 43.3705 39.6979C41.6886 35.9057 39.3426 31.9743 37.1145 29.1998C35.4755 27.1644 30.6121 22.3225 28.5768 20.7049C26.4129 18.9695 21.7744 16.2915 18.9142 15.1238C17.136 14.3847 15.1114 14.0954 14.4258 14.4704Z"
                      fill="white"
                    />
                    <path
                      d="M91.6182 25.1077C91.5646 25.1505 91.2754 25.4612 90.9969 25.7933C90.1292 26.8324 87.8796 28.5249 86.3691 29.2855C85.4907 29.7247 84.141 30.1318 82.9091 30.3353C81.72 30.5388 77.9814 30.5603 75.7104 30.3781C73.5679 30.2175 72.5395 30.2496 70.9755 30.5388C69.5401 30.7959 68.3296 31.1601 67.2905 31.6101C65.9193 32.2099 63.584 33.8918 61.3023 35.895C58.9885 37.9303 57.0388 39.3658 54.1251 41.1654C52.7432 42.0117 48.8546 44.197 48.4475 44.347C48.1155 44.4648 50.0544 45.6646 51.929 46.4895C56.9424 48.6855 61.5487 49.4032 68.1582 49.0176C75.4212 48.5784 78.0028 47.55 81.6771 43.64C82.1056 43.1794 82.5663 42.633 82.7055 42.4081C82.9626 42.0117 83.3161 41.6154 83.9053 41.0905C84.066 40.9405 84.3981 40.5548 84.6337 40.2335C84.8694 39.9121 85.3193 39.3551 85.6193 39.0016C86.6798 37.7589 89.5186 33.2276 90.2042 31.6636C91.1147 29.5961 91.7467 27.6037 91.886 26.3182C92.0145 25.097 91.961 24.8506 91.6182 25.1077Z"
                      fill="white"
                    />
                    <path
                      d="M0.0174701 26.1682C0.0603194 26.2646 0.403114 27.4108 0.788757 28.707C2.07423 33.0241 2.43845 33.8811 4.29168 36.9876C6.44486 40.6191 9.29434 43.8328 11.9724 45.6325C13.7614 46.843 17.2107 48.3641 19.3639 48.8997C24.6665 50.2066 31.0082 49.8531 36.5572 47.9463C37.8319 47.4964 40.2315 46.5323 41.6991 45.8574C42.5775 45.4611 43.8951 44.6577 43.8951 44.5291C43.8951 44.4863 43.6487 44.3899 43.3381 44.3042C42.1704 44.0149 38.539 41.9474 35.3253 39.7728C34.2326 39.0337 32.6043 37.7911 30.6118 36.1628C26.0163 32.4242 24.1845 31.4708 20.2745 30.7959C18.8497 30.5495 17.35 30.5388 15.711 30.7531C13.8578 30.9995 10.8369 30.978 9.24077 30.6995C5.63072 30.0782 3.55253 29.1141 1.44221 27.0466C0.831606 26.4467 0.274566 25.9861 0.15673 25.9861C0.0067578 25.9861 -0.0253791 26.0397 0.0174701 26.1682Z"
                      fill="white"
                    />
                    <path
                      d="M45.1808 45.8682C41.6671 48.2999 39.8246 49.2318 37.0394 49.9817C34.1149 50.7637 31.5654 51.0529 27.5483 51.0529C24.5488 51.0529 22.8456 50.9351 20.4889 50.5709C19.8997 50.4852 18.9463 50.3352 18.3678 50.2495C17.7787 50.1638 16.7074 49.971 15.9683 49.821C15.2398 49.671 14.565 49.5532 14.4793 49.5532C14.2008 49.5532 15.6791 51.5564 17.318 53.3989C18.9784 55.2521 21.3566 56.9661 23.0598 57.5124C23.3598 57.6089 24.4417 57.8124 25.4701 57.9624C27.6661 58.273 28.6195 58.5194 29.83 59.0872C31.1476 59.6978 31.5976 60.0513 33.2365 61.7117C34.7898 63.2864 35.1969 63.5756 36.2574 63.8541C37.5322 64.1862 38.3463 63.9934 40.6495 62.8365C42.6848 61.8081 43.2311 61.6474 45.4593 61.4439C47.741 61.2296 50.312 61.6367 51.726 62.4401C53.8899 63.672 55.6253 64.0684 57.0286 63.6399C57.6392 63.4578 58.0998 63.1043 59.8138 61.5188C61.0029 60.4155 62.2134 59.5264 63.4988 58.7872C64.6772 58.123 67.6766 56.9447 69.712 56.3555C72.9364 55.4128 74.4361 54.3844 75.968 52.0813C76.6964 50.9779 77.9176 48.6105 77.8105 48.5034C77.7783 48.482 77.457 48.5569 77.082 48.6855C75.8823 49.0819 72.6043 49.7032 69.6584 50.0995C68.3194 50.2816 67.1839 50.3459 64.5272 50.378C60.7565 50.4423 59.2353 50.3459 57.0714 49.9174C55.4003 49.5853 54.854 49.4246 53.3757 48.8569C51.8224 48.257 51.0404 47.8606 48.9194 46.5752C46.9483 45.3861 46.5412 45.1611 46.3377 45.1611C46.2627 45.1719 45.7378 45.4825 45.1808 45.8682Z"
                      fill="white"
                    />
                  </svg>
                </a>
                <Link
                  path="/"
                  component={
                    <Typography
                      sx={{
                        fontFamily: "average !important",
                      }}
                      typography={"h3"}
                      fontWeight={600}
                      letterSpacing={16}
                      lineHeight={1.5}
                      textTransform="uppercase"
                    >
                      Inspire <br /> Luxury
                    </Typography>
                  }
                />
              </>
              <SocialLinks />
              {/* <picture>
                <source srcSet={`/images/tourism.webp`} type="image/webp" />
                <img
                  src="/images/tourism.jpg"
                  width={240}
                  alt=""
                  style={{ borderRadius: 12 }}
                />
              </picture> */}
            </Stack>
          </Grid>
          
          {/* Vertical divider for desktop */}
          <Divider 
            orientation="vertical" 
            flexItem 
            sx={{ display: { xs: "none", md: "block" } }}
          />
          
          {/* Horizontal divider for mobile */}
          <Grid item xs={4} sx={{ display: { xs: "block", md: "none" } }}>
            <Divider sx={{ width: "100%", my: 2 }} />
          </Grid>

          <Grid item md width="100%">
            <Box 
              display="grid" 
              gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr" }}
              gap={{ xs: 8, sm: 4 }}
              ml={{ md: 12 }}
            >
              {/* General Column */}
              <Box>
                <Typography 
                  variant="h6" 
                  mb={2}
                  textAlign={{ xs: "center", sm: "left" }}
                >
                  General
                </Typography>
                <Stack spacing={1}>
                  <Link
                    path="/villas"
                    component={
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        textAlign={{ xs: "center", sm: "left" }}
                        py={1}
                        sx={{
                          "&:hover": { color: "text.primary" },
                        }}
                      >
                        Villas
                      </Typography>
                    }
                  />
                  <Link
                    path="/around-us"
                    component={
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        textAlign={{ xs: "center", sm: "left" }}
                        py={1}
                        sx={{
                          "&:hover": { color: "text.primary" },
                        }}
                      >
                        Around us
                      </Typography>
                    }
                  />
                </Stack>
              </Box>

              {/* Company Column */}
              <Box>
                <Typography 
                  variant="h6" 
                  mb={2}
                  textAlign={{ xs: "center", sm: "left" }}
                >
                  Company
                </Typography>
                <Stack spacing={1}>
                  <Link
                    path="/about-us"
                    component={
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        textAlign={{ xs: "center", sm: "left" }}
                        py={1}
                        sx={{
                          "&:hover": { color: "text.primary" },
                        }}
                      >
                        About us
                      </Typography>
                    }
                  />
                  <Link
                    path="/contact"
                    component={
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        textAlign={{ xs: "center", sm: "left" }}
                        py={1}
                        sx={{
                          "&:hover": { color: "text.primary" },
                        }}
                      >
                        Contact
                      </Typography>
                    }
                  />
                </Stack>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box pt={{ xs: 16, sm: 24 }}>
        <Box sx={{ background: "#00000030" }} py={2}>
          <a
            href="https://www.devgeeks.in"
            style={{ textDecoration: "none" }}
            target="_blank"
            rel="noreferrer"
          >
            <Typography style={{ fontWeight: 300 }} textAlign="center">
              Made with ❤️ by <u>DevGeeks</u> Agency
            </Typography>
          </a>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
